import React from "react"
import ProductListsData from "./components/ProductListsData";
import DocCode from "../DocCode";


const ProductLists = () => {

    // {/* x---------------------------------x Product Lists Code Section x---------------------------------x */}s
    const ProductListsCode =
        `
        <!--
            This example requires some changes to your config:

            // tailwind.config.js
            module.exports = {
                // ...
                plugins: [
            // ...
            require('@tailwindcss/aspect-ratio'),
            ],
            }
        -->
            <div className="bg-white">
                <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
                    <h2 className="text-2xl font-bold tracking-tight text-gray-900">Customers also purchased</h2>

                    <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
                        <div className="group relative">
                            <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-80">
                                <img src="https://tailwindui.com/plus/img/ecommerce-images/product-page-01-related-product-01.jpg" alt="Front of men&#039;s Basic Tee in black." className="h-full w-full object-cover object-center lg:h-full lg:w-full">
                            </div>
                            <div className="mt-4 flex justify-between">
                                <div>
                                    <h3 className="text-sm text-gray-700">
                                        <Link to="/">
                                            <span aria-hidden="true" className="absolute inset-0"></span>
                                            Basic Tee
                                        </Link>
                                    </h3>
                                    <p className="mt-1 text-sm text-gray-500">Black</p>
                                </div>
                                <p className="text-sm font-medium text-gray-900">$35</p>
                            </div>
                        </div>

                        <!-- More products... -->
                    </div>
                </div>
            </div>
        `

    return (
        // {/* x---------------------------------x DocCode Component Section x---------------------------------x */}
        <DocCode
            heading={"Product Lists"}
            headingText={"Use these Tailwind CSS product list components to build storefront and category pages for your online store with images, prices, and links to more details or purchase options. These components are designed and built by the Tailwind CSS team, and include a variety of different styles and layouts."}
            code={ProductListsCode}
            // {/* x---------------------------------x Product Lists Preview Section x---------------------------------x */}
            Preview={<ProductListsData />}
        />
    )
}


export default ProductLists;